"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Modifypass',
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;
    var validateOldPassword = function validateOldPassword(rule, value, callback) {
      if (!value || value.length < 6) {
        callback(new Error('请输入合法的密码'));
      } else if (_this.errorKeys.indexOf('oldPassword') >= 0) {
        callback(new Error(_this.errorInfo['oldPassword']));
        _this.resetError('oldPassword');
      } else {
        callback();
      }
    };
    var validateNewPassword = function validateNewPassword(rule, value, callback) {
      if (!value || value.length < 6) {
        callback(new Error('请输入合法的密码'));
      } else if (_this.errorKeys.indexOf('newPassword') >= 0) {
        callback(new Error(_this.errorInfo['newPassword']));
        _this.resetError('newPassword');
      } else {
        callback();
      }
    };
    var validateConfirmPassword = function validateConfirmPassword(rule, value, callback) {
      if (!value || value !== _this.modifyPassVal.newPassword) {
        callback(new Error(_this.$t('sysUser.error.confirmPassword')));
      } else if (_this.errorKeys.indexOf('confirmPassword') >= 0) {
        callback(new Error(_this.errorInfo['confirmPassword']));
        _this.resetError('confirmPassword');
      } else {
        callback();
      }
    };
    return {
      formLabelWidth: '120px',
      isLoading: false,
      isConfirm: false,
      dialogStatus: '修改密码',
      modifyPassVal: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      initModifyPassVal: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      modifyPassRules: {
        oldPassword: [{
          required: true,
          trigger: ['change'],
          validator: validateOldPassword
        }],
        newPassword: [{
          required: true,
          trigger: ['change'],
          validator: validateNewPassword
        }],
        confirmPassword: [{
          required: true,
          trigger: ['change'],
          validator: validateConfirmPassword
        }]
      },
      errorKeys: [],
      errorInfo: {}
    };
  },
  computed: {
    isVisible: {
      get: function get() {
        return this.isShow;
      },
      set: function set(val) {
        this.$emit('update:isShow', val);
      }
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)',
          target: '.model-content'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    isVisible: function isVisible(newValue) {
      var _this2 = this;
      if (newValue) {
        this.isConfirm = false;
        this.$nextTick(function () {
          _this2.$refs['modifyPassDataForm'].clearValidate();
        });
      } else {
        this.resetForm();
      }
    }
  },
  methods: {
    resetForm: function resetForm() {
      this.modifyPassVal = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
    },
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    saveModifyPass: function saveModifyPass() {
      var _this3 = this;
      if (this.isConfirm) {
        this.isVisible = false;
        return;
      }
      this.$refs.modifyPassDataForm.validate(function (valid) {
        if (!valid) return;
        _this3.isLoading = true;
        _this3.$api.sysUser.passModify(_this3.modifyPassVal).then(function (res) {
          _this3.isLoading = false;
          _this3.isConfirm = true;
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this3.resetError();
            err.errorInfos.forEach(function (item) {
              _this3.errorKeys.push(item.key);
              _this3.errorInfo[item.key] = item.errMsg;
            });
            _this3.$refs['modifyPassDataForm'].validate(function (valid) {
              console.log(valid);
            });
          }
          _this3.isLoading = false;
          // this.$message.error('保存失败')
        });
      });
    }
  }
};